import { render, staticRenderFns } from "./a-heading.vue?vue&type=template&id=4866a254&"
import script from "./a-heading.vue?vue&type=script&lang=js&"
export * from "./a-heading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports